import { useMemo } from 'react';
import PropTypes from 'prop-types';

import { Box, Button, Heading, Modal, Paragraph, Text } from '@zillow/constellation-10';

import { PREMIUM_FEATURES_BY_CONTEXT, PRODUCT_TYPE_NAME_TO_ID } from '../../../constants/FreemiumConstants';

import { getFreemiumProductByType } from '../../../utils/upsellUtils';

import ModularListingCSEvents from '../../../model/ClickstreamEvent/ModularListingCSEvents';

import { StyledFlex } from './StyledComponents';

const propTypes = {
  onClose: PropTypes.func.isRequired,
  onSelectUpgrade: PropTypes.func.isRequired,
};

const defaultProps = {};

const PremiumPurchaseModal = ({ onClose, onSelectUpgrade, freemiumProducts }) => {
  const upgradedProduct = useMemo(
    () => getFreemiumProductByType(freemiumProducts, PRODUCT_TYPE_NAME_TO_ID.PREMIUM),
    [freemiumProducts],
  );

  const renderPremiumUpsellItemList = () => {
    return Object.entries(PREMIUM_FEATURES_BY_CONTEXT).map(([key, value]) => {
      const { HEADING, BODY, ICON: Icon } = value.PAY_AND_PUBLISH;

      return (
        <Box key={key} css={{ display: 'flex', flexDirection: 'row', marginBottom: '600' }}>
          {/* need div container to prevent mismatching icon sizes */}
          <div>
            <Icon size={{ default: 'md' }} marginRight={{ default: 'sm' }} />
          </div>

          <Box>
            <Paragraph textStyle="body-lg-bold">{HEADING}</Paragraph>
            <Paragraph textStyle="body">{BODY}</Paragraph>
          </Box>
        </Box>
      );
    });
  };

  return (
    <Modal
      data-testid="PremiumPurchaseModal"
      size={{
        base: 'fullScreen',
        lg: 'md',
      }}
      open={true}
      onOpenChange={(open) => !open && onClose()}
      header={
        <Heading level={1} textStyle="heading-xs">
          About premium
        </Heading>
      }
      body={
        <div>
          <Heading css={{ marginBottom: '800' }} level={4}>
            Get the edge you need to fill your listing fast
          </Heading>
          <div>{renderPremiumUpsellItemList()}</div>
          <StyledFlex paddingTop="lg" paddingBottom="md" display="flex" justifyContent="space-between">
            <Text textStyle="heading-xs">Upgrade your listing to premium</Text>
            <Text textStyle="body-lg-bold">{upgradedProduct?.price}</Text>
          </StyledFlex>
        </div>
      }
      footer={
        <Button
          size="md"
          tone="brand"
          emphasis="filled"
          onClick={onSelectUpgrade}
          data-eventid={ModularListingCSEvents.ClickUpgradeToPremiumFromModal.data_event_id}
        >
          Upgrade to premium
        </Button>
      }
    />
  );
};

PremiumPurchaseModal.propTypes = propTypes;
PremiumPurchaseModal.defaultProps = defaultProps;

export default PremiumPurchaseModal;
